/* global jsPDF & html2canvas */
// for jsPDF import check components/app-main/client/main.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { get, isEmpty, find, cloneDeep, uniqBy, join, map, concat, chunk, extend } from 'lodash';
import AddressFormatter from '@shopify/address';
import { fetchBooking } from '../../app-main/actions/booking';
import { fetchPayment } from '../actions/payment';
import { fetchContractsSnapshot } from '../../app-main/actions/contracts';
import CurrentDetailsMain from '../../app-bookings-current-details/current-details-main';
import { PageSpinner } from 'shared-components/decorators/spinner';
import { normalizeContracts, priceBreakdownObject } from '../../app-bookings-request/forms/bookingUtil';
import Contracts from 'api/api-contracts';
import { injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { fetchEnvWeb } from '../../app-main/actions/env';
import { fetchInvoiceEntriesByType } from '../actions/invoices';
import { fetchAddressById } from '../actions/feeProfile';
import { Fees } from 'api/api-fees';
import TaxInvoice from 'shared-components/invoice/TaxInvoice';

class CurrentDetailsContainer extends Component {
  constructor (props) {
    super(props);

    this.state = {
      pdfProcessing: false,
      cancellationObj: {},
      fetchingCancelledContracts: false,
      invoiceId: '',
      invoiceMonth: '',
      invoiceCountry: '',
      invoiceYear: '',
      invoiceFeeName: 'VAT',
      userAddressFormatArray: [],
      psAddressObj: {}
    };

    this.redirectToInboxDetails = this.redirectToInboxDetails.bind(this);
    this.downloadToPDF = this.downloadToPDF.bind(this);
    this.downloadTaxInvoicePdf = this.downloadTaxInvoicePdf.bind(this);
  }

  componentDidMount () {
    const {
      dispatch,
      booking,
      accessToken,
      routeParams,
      iosWebView = false,
      scrollTopIOS = null,
      token = ''
    } = this.props;

    if (iosWebView) {
      scrollTopIOS();
    }

    const bookingId = get(routeParams, 'bookingID') || this.props.bookingId || get(booking, 'booking._id', '');
    const ssoId = PSSessions.Cookies('PSUser');

    dispatch(fetchBooking(bookingId, accessToken || token));
    dispatch(fetchEnvWeb());
    dispatch(fetchContractsSnapshot(bookingId, accessToken || token));
    dispatch(fetchPayment(bookingId, accessToken || token, ssoId));
  }

  componentWillReceiveProps (nextProps) {
    const { profile, booking, accessToken, token } = nextProps;
    const { cancellationObj, fetchingCancelledContracts } = this.state;
    const isHost = profile.SSOid === get(booking, 'booking.host.ssoid');
    const isGuest = profile.SSOid === get(booking, 'booking.guest.ssoid');

    // only booking hosts or guests can access form
    if (!isEmpty(booking.booking) && (!isGuest && !isHost) && !isEmpty(profile.data)) {
      window.location.href = '/inbox';
    }

    if (!isEmpty(booking.booking) && 'CANCELLED' === get(booking, 'booking.obj_state', '') && isEmpty(cancellationObj) && !fetchingCancelledContracts) {
      this.setState({ fetchingCancelledContracts: true }, () => {
        return Contracts.readContractCancellation(get(booking, 'booking._id', ''), (accessToken || token), response => {
          if (200 === response.statusCode) {
            this.setState({ cancellationObj: response, fetchingCancelledContracts: false });
          } else {
            this.setState({
              displayError: this.props.intl.formatMessage({ id: 'inbox.current_details_container.something_wrong', defaultMessage: 'Something went wrong, please try again.' }),
              fetchingCancelledContracts: false
            });
          }
        });
      });
    }
  }

  downloadToPDF () {
    this.setState({ pdfProcessing: true });
    window.scrollTo(0, 0);
    const contracts = get(this.props, 'contract.data.contracts', []);
    const invoiceId = get(find(contracts, { type: 'MASTER' }) || {}, 'invoice_id', null);
    const currentDetailsPage = document.getElementById('current-details-page');
    currentDetailsPage.classList.add('pdf-format');

    html2canvas(currentDetailsPage, {
      windowWidth: 1000,
      scale: 2,
      x: 0,
      width: 1100,
      allowTaint: true,
      useCORS: true,
      onclone: (clonedDoc) => {
        clonedDoc.getElementById('peerspace-logo').style.display = 'block';
      }
    }).then( function (canvas) {
      const imgData = canvas.toDataURL('image/jpeg');
      const doc = new jsPDF();
      const imgWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight + 10;
      let position = 10;

      doc.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save(`PeerspaceReceipt-${invoiceId}.pdf`);
    })
    setTimeout(() => { this.setState({ pdfProcessing: false }); }, 500);
    currentDetailsPage.classList.remove('pdf-format');
  }

  redirectToInboxDetails () {
    const bookingId = get(this.props, 'booking.booking._id');
    this.context.router.push({ pathname: `/inbox/${bookingId}` });
  }

  downloadTaxInvoicePdf (e, invoiceId, monthName, countryName, year, feeName) {
    e.preventDefault();
    const { accessToken, booking, profile, dispatch, env, feeProfiles } = this.props;
    const bookingId = get(booking, 'booking._id', '');
    const ssoId = get(profile, 'SSOid', '');
    const vatBusinessName = get(feeProfiles, 'vatAddresses.data[0].business_name', '');
    const profileData = get(profile, 'data', {});

    // make these api calls in parallel - no need to be synchronous
    Promise.all([
      dispatch(fetchInvoiceEntriesByType(accessToken, invoiceId, 'CHARGE')),
      dispatch(fetchInvoiceEntriesByType(accessToken, invoiceId, 'REFUND'))
    ]).then(values => {
      const vatProfileId = get(values, '[0].entries[0].fee_profile_id', null);
      const billingProfileId = get(values, '[0].entries[0].billing_profile_id', null);
      const feeProfileId = vatProfileId || billingProfileId;
      const totalEntries = concat(get(values, '[0].entries', []), get(values, '[1].entries', []));
      // Avoid duplicated ids (several charges for same entry)
      const uniqEntries = uniqBy(totalEntries, 'control_id');
      // Splits the array of all entries to chunks with <= 25 elements
      const chunks = chunk(uniqEntries, 25);

      // Makes a separate call for each chunk, to avoid requests with payload 25+ ids at a time
      Promise.all(chunks.map(chunk => {
        return new Promise(resolve => {
          const query = join(map(chunk, entry => get(entry, 'control_id')), ',');
          Contracts.fetchSpaceRentalsInfo(accessToken, query ? `?control_ids=${query}` : '', (spaceRentals) => {
            resolve(spaceRentals);
          });
        });
      })).then(spacesRentalsResponses => {
        // Concatenates all chunks responses into a single object
        const spaceRentals = extend.apply({}, spacesRentalsResponses);
        dispatch(fetchAddressById(accessToken, feeProfileId)).then(feeProfile => {
          const { street = '', unit = '', city = '', state = '', country = '', zip = '' } = feeProfile;
          Fees.fetchRegionalFees(accessToken, { country: country }, regionalFees => {
            if (200 === regionalFees.statusCode) {
              const region = get(regionalFees, 'regions[0]', {});
              const isEUCountry = 'EU' === get(region, 'code', '');
              const locale = SharedIntlProviderHOC.getLocale();
              const localeCode = locale.split('-')[0];

              const addressFormatter = new AddressFormatter(localeCode);
              const psAddressObj = isEUCountry ?
                get(env, 'web.ps_addresses.GB', '')
                :
                get(env, `web.ps_addresses[${country}]`, '');

              if (!isEmpty(feeProfile)) {
                const orderedFields = addressFormatter.format({
                  address1: street,
                  address2: unit,
                  province: state,
                  city,
                  zip,
                  country
                }).then(addressFormat => {
                  this.setState({
                    invoiceId: invoiceId,
                    invoiceMonth: monthName,
                    invoiceCountry: countryName,
                    invoiceYear: year,
                    invoiceFeeName: feeName,
                    userAddressFormatArray: addressFormat,
                    psAddressObj
                  }, () => {
                    const { invoiceYear, invoiceMonth, invoiceCountry, invoiceFeeName, userAddressFormatArray } = this.state;
                    const { feeProfiles, invoices } = this.props;
                    const invoiceEntriesByType = get(invoices, 'invoiceEntriesByType', {});
                    const userFeeProfile = get(feeProfiles, 'invoiceFeeProfile.data', {});
                    const pdfContainer = document.getElementById('invoice-pdf-container');
                    ReactDOM.render(
                      <SharedIntlProviderHOC iosLocale={this.state.locale}>
                        <TaxInvoice
                          invoiceId={invoiceId}
                          date={`${invoiceMonth} ${invoiceYear}`}
                          invoiceCountry={invoiceCountry}
                          invoiceFeeName={invoiceFeeName}
                          intl={this.props.intl}
                          profile={profileData}
                          userFeeProfile={userFeeProfile}
                          userAddressFormatArray={userAddressFormatArray}
                          psAddressObj={psAddressObj}
                          invoiceEntriesByType={invoiceEntriesByType}
                          businessName={vatBusinessName}
                          locale={locale}
                          spaceRentals={spaceRentals}
                        />
                      </SharedIntlProviderHOC>, pdfContainer);
                    const pdfPage = document.getElementById('invoice-pdf-page');
                    html2canvas(pdfPage, {
                      windowWidth: 1000,
                      scale: 2,
                      x: 0,
                      width: 1100,
                      allowTaint: true,
                      useCORS: true,
                      onclone: function (clonedDoc) {
                        clonedDoc.getElementById('invoice-pdf-page').style.display = 'block';
                        clonedDoc.getElementById('peerspace-logo').style.display = 'block';
                      }
                    }).then(function (canvas) {
                      const image = { type: 'jpeg', quality: 0.98 };
                      const margin = [0.5, 0.5];
                      let imgWidth = 8.5;
                      let pageHeight = 11;

                      let innerPageWidth = imgWidth - margin[0] * 2;
                      let innerPageHeight = pageHeight - margin[1] * 2;

                      // Calculate the number of pages.
                      let pxFullHeight = canvas.height;
                      let pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
                      let nPages = Math.ceil(pxFullHeight / pxPageHeight);

                      // Define pageHeight separately so it can be trimmed on the final page.
                      pageHeight = innerPageHeight;

                      // Create a one-page canvas to split up the full image.
                      let pageCanvas = document.createElement('canvas');
                      let pageCtx = pageCanvas.getContext('2d');
                      pageCanvas.width = canvas.width;
                      pageCanvas.height = pxPageHeight;

                      // Initialize the PDF.
                      let doc = new jsPDF('p', 'in', [8.5, 11]);
                      for (let page = 0; page < nPages; page++) {
                      // Trim the final page to reduce file size.
                        if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
                          pageCanvas.height = pxFullHeight % pxPageHeight;
                          pageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
                        }

                        // Display the page.
                        let w = pageCanvas.width;
                        let h = pageCanvas.height;
                        pageCtx.fillStyle = 'white';
                        pageCtx.fillRect(0, 0, w, h);
                        pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

                        // Add the page to the PDF.
                        if (page > 0) doc.addPage();
                        let imgData = pageCanvas.toDataURL('image/' + image.type, image.quality);
                        doc.addImage(imgData, image.type, margin[1], margin[0], innerPageWidth, pageHeight);
                      }
                      const fileName = `PeerspaceTaxInvoice-${invoiceId}.pdf`;
                      doc.save(fileName);
                      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
                      ReactDOM.unmountComponentAtNode(pdfContainer);
                    });
                  });
                });
              }
            }
          });
        });
      });
    });
  }

  render () {
    const {
      booking,
      iosWebView,
      toggleModal,
      whichModal,
      contract,
      profile,
      closeIOSModal,
      payment,
      accessToken,
      env,
      dispatch,
      invoices
    } = this.props;

    const bookingId = get(booking, 'booking._id', '');
    const { pdfProcessing, cancellationObj } = this.state;

    const ssoId = profile.SSOid;
    const hostSsoId = get(booking, 'booking.host.ssoid', null);
    const isHost = hostSsoId === ssoId;

    const pendingContract = get(contract, 'data.pending', {});
    const pendingMasterContract = find(pendingContract, { type: 'MASTER' }) || {};
    const isHostUpdate = 'HOST_UPDATE_SUBMITTED' === pendingMasterContract.state;
    const isRequestedState = 'PENDING_GUEST_REQUEST_ACCEPT' === pendingMasterContract.state;

    const cancelledContracts = get(cancellationObj, 'previous', []);
    const cancelledRefund = get(cancellationObj, 'delta.guest.payment', 0);
    const cancelledTotal = get(find(get(contract, 'data.contracts'), { type: 'MASTER' }) || {}, 'calculations.guest.payment', {});

    // here is where we decide what contracts to display (cancelled, pending, current)
    const displayContracts = cancelledContracts.length ? cancelledContracts : isRequestedState ? pendingContract : get(contract, 'data.contracts');
    const normalizedContracts = normalizeContracts(displayContracts);
    const priceBreakdown = priceBreakdownObject(normalizedContracts);
    const bookingDetails = get(normalizedContracts, 'bookingObject') || booking.booking;
    const spaceRentalContract = get(normalizedContracts, 'spaceRentalContract');

    const vatEnabledCountries = (
      window.vat_launched_countries_hash || ''
    ).split(' ');
    const listingCountry = get(spaceRentalContract, 'meta.listing.country');
    const isVatEnabled = vatEnabledCountries.includes(listingCountry);

    const {
      cleaningFee,
      spaceRentalSubtotal,
      spaceRentalTotal,
      currency,
      itemsArray,
      adjustmentsArray,
      addOnsTotal,
      total,
      hostPayout,
      guestPayment,
      hostFee,
      guestFee,
      hostAddOnsSummary,
      discounts
    } = priceBreakdown;

    const loadingCancelledObj = 'CANCELLED' === get(booking, 'booking.obj_state', '') && isEmpty(cancellationObj);
    const activityDetailBooking = cloneDeep(bookingDetails);
    if (!_.isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = isHost ? 'HOST' : 'GUEST';
      activityDetailBooking.attendees = activityDetailBooking.number_of_guests;
      activityDetailBooking.spaceRental = spaceRentalTotal;
      activityDetailBooking.listing = get(booking, 'booking.listing', {});
      if (isHost) {
        _.set(activityDetailBooking, 'guest.sso_id', _.get(booking, 'guest.ssoid'));
        delete activityDetailBooking.host;
      }
    }

    return (
      <div className="CurrentDetailsContainer">
        {
          (isEmpty(contract.data) || isEmpty(booking.booking) || loadingCancelledObj || isEmpty(env.web))
            ? <PageSpinner additionalStyle="gray" />
            :
            <CurrentDetailsMain
              booking={booking.booking}
              activityDetailBooking={activityDetailBooking}
              masterContract={normalizedContracts.masterContract}
              normalizedContracts={normalizedContracts}
              profile={profile}
              spaceRentalSubtotal={spaceRentalSubtotal}
              spaceRentalTotal={spaceRentalTotal}
              cleaningFee={cleaningFee}
              currency={currency}
              itemsArray={itemsArray}
              adjustmentsArray={adjustmentsArray}
              addOnsTotal={addOnsTotal}
              hostAddOnsSummary={hostAddOnsSummary}
              subtotal={total[ssoId]}
              processingFee={isHost ? hostFee : guestFee}
              total={isHost ? hostPayout : guestPayment}
              iosWebView={iosWebView}
              toggleModal={toggleModal}
              isHost={isHost}
              ssoId={ssoId}
              whichModal={whichModal}
              closeIOSModal={closeIOSModal}
              redirectToInboxDetails={this.redirectToInboxDetails}
              isHostUpdate={isHostUpdate}
              payment={get(payment, 'data', {})}
              downloadToPDF={this.downloadToPDF}
              pdfProcessing={pdfProcessing}
              cancelledTotal={cancelledTotal}
              cancelledRefund={cancelledRefund}
              discounts={discounts}
              isVatEnabled={isVatEnabled}
              accessToken={accessToken}
              env={env}
              downloadTaxInvoicePdf={this.downloadTaxInvoicePdf}
              dispatch={dispatch}
              bookingId={bookingId}
              invoices={invoices}
            />
        }
      </div>
    );
  }
}

CurrentDetailsContainer.propTypes = {
  booking: PropTypes.object,
  iosWebView: PropTypes.bool,
  toggleModal: PropTypes.func,
  contract: PropTypes.object,
  profile: PropTypes.object,
  dispatch: PropTypes.func,
  accessToken: PropTypes.string,
  routeParams: PropTypes.object,
  scrollTopIOS: PropTypes.func,
  whichModal: PropTypes.func,
  token: PropTypes.string,
  bookingId: PropTypes.string,
  closeIOSModal: PropTypes.func,
  intl: intlShape
};

function mapStateToProps (state) {
  const { auth, booking, add_ons, contract, profile, payment, env, invoices,
  feeProfiles } = state;
  const { accessToken } = auth;
  const addOnStep = get(add_ons, 'step');

  return {
    booking,
    accessToken,
    addOnStep,
    contract,
    profile,
    payment,
    env,
    invoices,
    feeProfiles
  };
}

CurrentDetailsContainer.contextTypes = {
  router: PropTypes.object
};

export default injectIntl(connect(mapStateToProps)(CurrentDetailsContainer));
